export const LOCAL_STORAGE_KEYS = {
  POKEMON_CART: 'POKEMON_CART'
}
